// @ts-strict-ignore
import {Component, Input, OnChanges, OnInit, output, SimpleChanges} from "@angular/core";
import {Router} from "@angular/router";
import {Location} from "@angular/common";
import {Event, TrainingSessionClientData, TrainingSessionUserData, WebClientType} from "@models";
import {fadeInOnEnterAnimation, fadeOutOnLeaveAnimation, zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {SimRecorderService, SimSystemService, TrackByMethods} from "@services";
import {Translations} from "@translations";

/**
 * @deprecated use app-side-action-bar instead
 */
@Component({
	selector: "sim-old-side-action-bar",
	templateUrl: "./old-side-action-bar.component.html",
	styleUrls: ["./old-side-action-bar.component.scss"],
	animations: [
		zoomInOnEnterAnimation({duration: 175}),
		zoomOutOnLeaveAnimation({duration: 175}),
		fadeInOnEnterAnimation({duration: 175}),
		fadeOutOnLeaveAnimation({duration: 175}),
	],
	standalone: false,
})
export class OldSideActionBarComponent implements OnInit, OnChanges {
	T = Translations;
	@Input() isTwoScreen: boolean;
	@Input() sessionClientData: {[key: string]: TrainingSessionClientData};
	deviceClickedEmitter = output<{
		event: MouseEvent;
		device: any;
	}>();
	@Input() showDeviceButtons: boolean = false;
	@Input() stageDesignerButtonActive: boolean = true;
	stageDesignerClicked = output<void>();
	editButtonClicked = output<void>();
	leaveButtonClicked = output<void>();
	@Input() showStageDesignerButton: boolean = true;
	@Input() showEditButton: boolean = false;
	@Input() showDeleteButton: boolean = false;
	@Input() event: Event;
	@Input() editButtonEnabled: boolean = false;
	@Input() userData: {[key: string]: TrainingSessionUserData};

	WebClientType = WebClientType;
	TrackByMethods = TrackByMethods;

	deviceIds: {clientId: string; userId: string}[] = [];
	@Input() leaveApplicationStrategy: "back" | "home" = "home";
	@Input() returnUrl?: string = null;
	deleteEventEmitter = output<Event>();

	constructor(
		private _router: Router,
		private _location: Location,
		private _simRecorderService: SimRecorderService,
		private _simSystemService: SimSystemService,
	) {}

	ngOnInit(): void {}

	openInfoPanel($event: MouseEvent, device: any) {
		this.deviceClickedEmitter.emit({event: $event, device: device});
	}

	openStageDesigner() {
		this.stageDesignerClicked.emit();
	}

	leaveApplication() {
		this.leaveButtonClicked.emit();
		if (this.leaveApplicationStrategy === "back") {
			//window.history.back();
			if (this.returnUrl) {
				this._router.navigate([this.returnUrl]);
			} else {
				this._location.back();
			}
		} else {
			this._router.navigate(["/"]);
		}
	}

	editButtonClickedEmit() {
		this.editButtonClicked.emit();
	}
	deleteEvent() {
		this.deleteEventEmitter.emit(this.event);
	}

	async ngOnChanges(changes: SimpleChanges) {
		if (changes["sessionClientData"]) {
			if (this.sessionClientData) {
				await this.generateDeviceIdsFromSessionClientData();
			}
		}
	}

	private async generateDeviceIdsFromSessionClientData() {
		this.deviceIds = [];
		for (let deviceId in this.sessionClientData) {
			let userId;

			switch (this.sessionClientData[deviceId].clientType) {
				case WebClientType.Recorder:
					await this._simRecorderService.getRecorderMappingById(deviceId).then((mapping) => (userId = mapping.info.userId));
					break;
				case WebClientType.Tablet:
					await this._simSystemService.getTabletMappingById(deviceId).then((mapping) => (userId = mapping.info.userId));
					break;
				case WebClientType.ViewingStation:
					await this._simSystemService.getViewingStationMappingById(deviceId).then((mapping) => (userId = mapping.info.userId));
					break;
			}
			let hasValue = this.deviceIds.some((val) => {
				return val.clientId === deviceId && val.userId === userId;
			});

			if (!hasValue) {
				this.deviceIds.push({clientId: deviceId, userId: userId});
			}
		}
	}
}
